<template>
  <div>
    <div
      class="bg-white overflow-hidden shadow rounded-lg max-w-xl mx-auto mt-10"
    >
      <div class="px-4 py-5 sm:p-6 ">
        <p class="text-sm font-semibold">
          Please follow the steps below to get started
        </p>
        <div class="flex flex-col">
          <img
            class="my-4  object-contain border border-gray-300 rounded-md"
            src="../assets/chatonboarding/onboarding_1.png"
          />
          <img
            class="my-4  object-contain border border-gray-300 rounded-md"
            src="../assets/chatonboarding/onboarding_2.png"
          />
          <img
            class="my-4  object-contain border border-gray-300 rounded-md"
            src="../assets/chatonboarding/onboarding_3.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
